import { PlusSmIcon, MinusSmIcon } from "@heroicons/react/outline";
import classnames from "classnames";
import { useMenuContext } from "context/MenuContext";

interface Props {
  count: number;
  changeCount: (action: "DECREMENT" | "INCREMENT") => void;
  size: "big" | "small";
}

// TODO: Do we really need size in here?
const CartCount: React.FC<Props> = ({ count, changeCount, size = "big" }) => {
  const { features } = useMenuContext();
  const iconClassName = classnames(
    "-ml-px relative inline-flex items-center py-2 px-2 border border-gray-300 bg-white text-gray-900 active:bg-gray-100 "
  );
  const iconSizeClassName = classnames("h-4 w-4", {
    "h-3 w-3 text-gray-900": size === "small",
  });
  const numberClassName = classnames(
    "-ml-px text-center w-9 py-1 border border-gray-300 bg-white text-base text-gray-900",
    {
      "text-sm text-gray-900": size === "small",
    }
  );
  return features !== "CATALOGO" ? (
    <div className="inline-flex" role="group" aria-label="Button group">
      <button
        aria-label="Decrement"
        type="button"
        className={iconClassName + "rounded-l-md"}
        onClick={() => changeCount("DECREMENT")}
      >
        <MinusSmIcon className={iconSizeClassName} aria-hidden="true" />
      </button>
      <div className={numberClassName}>{count}</div>
      <button
        aria-label="Increment"
        type="button"
        className={iconClassName + "rounded-r-md"}
        onClick={() => changeCount("INCREMENT")}
      >
        <PlusSmIcon className={iconSizeClassName} aria-hidden="true" />
      </button>
    </div>
  ) : null;
};
export default CartCount;
